// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HashtagIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HashtagIcon" ref={forwardedRef} {...props}>
      <path d="m8.604 3.5-.93 3.473H4v1.5h3.271l-.803 3H3.25v1.5h2.816l-.827 3.084 1.449.388.93-3.472h3.448l-.827 3.084 1.449.388.93-3.472h3.632v-1.5h-3.23l.804-3H17v-1.5h-2.774l.827-3.085-1.45-.388-.93 3.473H9.226l.827-3.085zm2.864 7.973H8.02l.804-3h3.447z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HashtagIcon = /* @__PURE__ */ Object.assign(HashtagIconComponent, {
  displayName: 'HashtagIcon',
});
